export const CUSTOMER_ORDER = {
    BASE_PATH: '/sale-order/customer-order/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    ADD_BUTTON_TITLE: 'Add New Customer Order',
    ADD_PAGE_TITLE: 'Add New Customer Order',
    LIST_PAGE_TITLE: 'Customer Order List',
    EDIT_PAGE_TITLE: 'Edit Customer Order',
    EDIT_PATH(id: string | number) {
        return `${this.BASE_PATH}${id}/edit`;
    },
    GET_ALL: 'customer-orders',
    GET_ONE: 'customer-orders/',
    CREATE: 'customer-orders',
    UPDATE: 'customer-orders/',
    DELETE: 'customer-orders/',
};
